import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconNames } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { IconButton } from '../../../../components/icon-button/icon-button';
import { useFeatureFlags } from '../../../../hooks';
import { getIsDigitalGreeting } from '../../../../utils';
import { AddressFooterProps } from '../../address-types';
import styles from './address-footer-styles.module.scss';

export const AddressFooter = ({
  isValid,
  submitLabel,
  goBack,
  isAddressLoading,
  addClass,
  handleSubmit,
}: AddressFooterProps): React.ReactElement => {
  const { t } = useTranslation();
  const { IS_MULT_ADDRESS_ENABLED } = useFeatureFlags();
  const isDigitalGreeting = getIsDigitalGreeting();
  const shouldDisplayFooter = !IS_MULT_ADDRESS_ENABLED || isDigitalGreeting;

  return shouldDisplayFooter ? (
    <div className={styles['address-footer']}>
      {/* <Button
        variant="link"
        onClickCapture={goBack}
        className={classNames(addClass, styles['footer-button'])}
        testId={'address-form-back-button'}
      >
        <Icon name={IconNames.ArrowsTailLeftBold} />
        {t('addressForm.back')}
      </Button> */}
      <IconButton
        onClick={goBack}
        variant="link"
        testId={'address-form-back-button'}
        className={classNames(addClass, styles['footer-button'])}
        label={t('addressForm.back')}
        iconPosition="left"
        iconName={IconNames.ArrowsTailLeftBold}
      />
      <Button
        type="submit"
        variant="primary"
        onClick={handleSubmit}
        className={classNames(addClass, styles['footer-button'])}
        disabled={!isValid || isAddressLoading}
        tabIndex={isValid ? 0 : -1}
        testId={'address-form-continue-submit'}
      >
        {submitLabel}
      </Button>
    </div>
  ) : (
    <></>
  );
};
